import { requestHelpers } from '../../helpers';

const actions = {
    GET_JOB_NOTIFICATIONS: 'GET_JOB_NOTIFICATIONS',
    SET_JOB_NOTIFICATIONS: 'SET_JOB_NOTIFICATIONS',
    GET_FORUM_NOTIFICATIONS: 'GET_FORUM_NOTIFICATIONS',
    SET_FORUM_NOTIFICATIONS: 'SET_FORUM_NOTIFICATIONS',
    GET_MESSAGING_NOTIFICATIONS: 'GET_MESSAGING_NOTIFICATIONS',
    SET_MESSAGING_NOTIFICATIONS: 'SET_MESSAGING_NOTIFICATIONS',
};

// const person_id = localStorage.getItem( 'person_id' );

function getJobNotifications( networkId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_JOB_NOTIFICATIONS,
            networkId,
        } );
        
        const person_id = localStorage.getItem( 'person_id' );

        requestHelpers
            .authenticatedGetRequest( '/notifications/jobs', { network_id: networkId, person_id } )
            .then( ( response ) => {
                // console.log( 'get job notification', response );
                dispatch( {
                    type: actions.SET_JOB_NOTIFICATIONS,
                    jobs: response.data,
                    networkId,
                } );
            } );
    }
}

function getForumNotifications( networkId ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_FORUM_NOTIFICATIONS,
            networkId,
        } );

        const person_id = localStorage.getItem( 'person_id' );

        requestHelpers
            .authenticatedGetRequest( '/notifications/forums', { network_id: networkId, person_id } )
            .then( ( response ) => {
                // console.log( response );
                dispatch( {
                    type: actions.SET_FORUM_NOTIFICATIONS,
                    forums: response.data,
                    networkId,
                } )
            } );
    }
}

function getMessageNotifications() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_MESSAGING_NOTIFICATIONS,
        } );

        requestHelpers
            .authenticatedGetRequest( '/notifications/messages' )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_MESSAGING_NOTIFICATIONS,
                    messages: response.data,
                } );
            } );
    }
}

module.exports = {
    actions,
    getJobNotifications,
    getForumNotifications,
    getMessageNotifications
};



// WEBPACK FOOTER //
// src/client/actions/notifications/notifications.js